import { Row, Col } from '@si-armes/dsfr-react';
import React from 'react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';

const InformationPersonneRisque = () => {
    const { formState } = useFormContext();

    return (
        <>
            <Row>
                <Col col={12}>
                    <h3>Informations sur les personnes à risques</h3>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>
                        Veuillez renseigner votre autorisation de port d'arme délivrée par le
                        Ministère de l'Intérieur *
                    </p>
                </Col>
            </Row>

            <Row gutters>
                <Col col={12} lg={6}>
                    <InputFiles
                        id="autorisationDetentionArme"
                        name="autorisationDetentionArme"
                        label="Ajouter mon autorisation de port d'arme"
                        error={formState.errors ? formState.errors.autorisationDetentionArme : null}
                        required
                    />
                </Col>
            </Row>
        </>
    );
};

export default InformationPersonneRisque;
